module.exports = __webpack_public_path__ + "img/50-25-25.4f4fb25a.svg";